const modalMassService = {
  massServiceTipography: 'Servicio en massa',
  autocomplete: 'Servicio',
  date: 'fecha de vencimiento',
  errorTitle: 'Tipos de equipo divergentes',
  error: 'Todos los tipos de equipos deben ser iguales y tener al menos algún servicio de equipo como servicio masivo habilitado en los parámetros',
  comment: '[BULK] SERVICIO REALIZADO EN MASA'
}
  
export default modalMassService;